import { Component, ViewChild, inject } from '@angular/core';
import { FilterListComponent } from 'gung-list';
import { ReturnOrderListConfigService } from '../../services/return-order-list-config/return-order-list-config.service';
import { ReturnOrder } from '../../models/return-order';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'lib-return-order-list',
    template: `<lib-filter-list #returnOrderList [configService]="returnOrderListConfigService"></lib-filter-list>`,
    styleUrls: ['./return-order-list.component.scss'],
    standalone: false
})
export class ReturnOrderListComponent {
  public returnOrderListConfigService = inject(ReturnOrderListConfigService);
  protected route = inject(ActivatedRoute);

  constructor() {
    const customerId = this.route.snapshot.params.customerId;

    if (customerId != null) {
      this.returnOrderListConfigService.setCustomerId(customerId);
    } else {
      this.returnOrderListConfigService.setCustomerId(null);
    }
  }

  @ViewChild('returnOrderList') returnOrderList: FilterListComponent<ReturnOrder>;
}
